/**
 * svgtoreact
 *
 * @author Michael Hsu
 */

import React from 'react';

export default function SVGCode(props) {
  return (
    <svg width={152} height={102} viewBox="0 0 152 102" {...props}>
      <g>
        <rect
          id="Rectangle-25"
          fill="#fff"
          x={1}
          y={1}
          width={150}
          height={100}
          rx={2}
        />
        <path
          d="M143 1h5.993c1.108 0 2.007.895 2.007 1.998v96.005c0 1.103-.9 1.998-2.007 1.998h-145.986c-1.108 0-2.007-.895-2.007-1.998v-6.002h139.993c1.107 0 2.007-.894 2.007-1.998v-90.002z"
          id="Combined-Shape"
          fill="#E6F5FB"
        />
        <path
          d="M1 3.009c0-1.109.9-2.009 2.007-2.009h145.986c1.108 0 2.007.902 2.007 2.009v9.991h-150v-9.991z"
          fill="#97D9F2"
        />
        <path
          d="M7 9c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2zm8 0c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2zm8 0c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2zM11 23h20v4h-20v-4zm0 48h20v4h-20v-4zm20-36h110v4h-110v-4zm0 24h40v4h-40v-4zm10-12h50v4h-50v-4z"
          id="Combined-Shape"
          fill="#CBECF9"
        />
        <path
          d="M2 2.998v96.005c0 .549.45.998 1.007.998h145.986c.556 0 1.007-.448 1.007-.998v-96.005c0-.549-.45-.998-1.007-.998h-145.986c-.556 0-1.007.448-1.007.998zm-2 0c0-1.656 1.348-2.998 3.007-2.998h145.986c1.659 0 3.007 1.342 3.007 2.998v96.005c0 1.656-1.348 2.998-3.007 2.998h-145.986c-1.659 0-3.007-1.342-3.007-2.998v-96.005zm150 9.002v-8.991c0-.556-.452-1.009-1.007-1.009h-145.986c-.555 0-1.007.452-1.007 1.009v8.991h148zm-150-8.991c0-1.661 1.347-3.009 3.007-3.009h145.986c1.66 0 3.007 1.349 3.007 3.009v10.991h-152v-10.991z"
          fill="#00A1DE"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/SVG/SVGCode.js